export var DimensionsXs;
(function (DimensionsXs) {
    DimensionsXs["compactHeaderHeight"] = "40px";
    DimensionsXs["headerHeight"] = "60px";
})(DimensionsXs || (DimensionsXs = {}));
export var DimensionsSm;
(function (DimensionsSm) {
    DimensionsSm["compactHeaderHeight"] = "65px";
    DimensionsSm["headerHeight"] = "75px";
})(DimensionsSm || (DimensionsSm = {}));
//# sourceMappingURL=dimensions.js.map